import { fetchChats } from "@/libs/api/requests";
import { useEffect } from "react";
import { useChatContext } from "./useChatContext";

export function useChats() {
  const { conversations, loading, error, setContext } = useChatContext();

  useEffect(() => {
    if (conversations.size > 0) {
      return;
    }

    setContext({ type: "loading", payload: true });

    fetchChats({
      offset: 0,
      limit: 20,
    })
      .then((data) => {
        if (data?.items) {
          setContext({ type: "setConversations", payload: data.items });
        }
      })
      .catch((err) => {
        setContext({ type: "error", payload: err.message });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    data: Array.from(conversations.values()),
    loading: loading,
    error: error,
  };
}
